import { Account } from '@/types';

/**
 * An account has something to show the user when it carries at least one
 * order or one eligibility. This is the single source of truth for that
 * decision — used to decide whether to hydrate post-fetch and whether the
 * account dashboard has anything to render (vs. routing to invalid-email).
 */
const accountHasContent = (account?: Account): boolean =>
  Boolean(account?.orders?.length) || Boolean(account?.eligibilities?.length);

export default accountHasContent;
